// extracted by mini-css-extract-plugin
module.exports = {"link":"iIPKt","image":"_300uv","root":"yFm0e"};